import { ColorEnum } from '@/constants/color'
import Typography from '@/features/ui/typography'
import { FC } from 'react'
import { StyleProp, TextStyle } from 'react-native'
import { createStyleSheet, useStyles } from 'react-native-unistyles'

interface ValueOrPlaceholderProps {
    value: string
    placeholder?: string
    numberOfLines?: number
    textStyle?: StyleProp<TextStyle>
}

const ValueOrPlaceholder: FC<ValueOrPlaceholderProps> = ({
    value,
    placeholder,
    numberOfLines = 1,
    textStyle,
}) => {
    const { styles } = useStyles(stylesheet, { hasValues: !!value })

    if (!value && !placeholder) return

    return (
        <Typography.Description
            font="medium"
            numberOfLines={numberOfLines}
            style={[styles.text, textStyle]}
        >
            {value || placeholder}
        </Typography.Description>
    )
}

const stylesheet = createStyleSheet({
    text: {
        variants: {
            hasValues: {
                false: {
                    color: ColorEnum.GRAY_300,
                },
                true: {
                    color: ColorEnum.GRAY_900,
                },
            },
        },
    },
})

export default ValueOrPlaceholder
